import { CommonModule } from '@angular/common';
import {
  Component,
  DOCUMENT,
  inject,
  OnDestroy,
  OnInit,
  Renderer2,
  signal,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ApiService } from '@solcre-org/core';
import { AlertService, AlertType, LayoutAuth } from '@solcre-org/core-ui';
import { environment } from '../../../../environments/environment.local';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-forgot-password',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterModule,
    RouterLink,
    LayoutAuth,
  ],
  templateUrl: './forgot-password.html',
})
export class ForgotPassword implements OnInit, OnDestroy {
  private apiService = inject(ApiService);
  private formBuilder: FormBuilder = inject(FormBuilder);
  private renderer: Renderer2 = inject(Renderer2);
  private document: Document = inject(DOCUMENT);
  private alertService: AlertService = inject(AlertService);
  private router: Router = inject(Router);

  form!: FormGroup;
  loading = signal<boolean>(false);
  config: any = {
    mainLogoUrl: '/assets/images/logo_blanco.svg',
  };

  ngOnInit(): void {
    this.renderer.addClass(this.document.documentElement, 'page-styles');
    this.renderer.addClass(this.document.documentElement, 'is-onboarding');

    this.form = this.formBuilder.group({
      email: this.formBuilder.control('', [
        Validators.required,
        Validators.email,
      ]),
    });
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(this.document.documentElement, 'page-styles');
    this.renderer.removeClass(this.document.documentElement, 'is-onboarding');
  }

  onFormSubmit() {
    if (this.form.valid) {
      this.loading.set(true);

      this.apiService
        .createObj(environment.API.FORGOT_PASSWORD, this.form.getRawValue())
        .subscribe({
          next: () => {
            this.loading.set(false);
            this.form.reset();
            this.router.navigate([environment.STATES.LOGIN]);
            this.alertService.show({
              type: AlertType.SUCCESS,
              message: 'forgotPassword.success',
              duration: 2000,
              inBottom: true,
            });
          },
          error: (error: HttpErrorResponse) => {
            this.loading.set(false);
            this.alertService.show({
              type: AlertType.ERROR,
              message: error.error?.detail ?? `errors.generic`,
              duration: 2000,
              inBottom: true,
            });
          },
        });
    }
  }
}
